import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import Layout from 'Components/Layout';
import NewBusinessForm from 'Components/Business/NewBusinessForm';
import { create } from 'store/slices/businessSlice';

class New extends Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
  }

  create(name, domain) {
    return this.props.create(name, domain).then(business => {
      setImmediate(() => this.props.history.push(`/business/${business.objectId}`));
      return business;
    });
  }

  render() {
    const {
      error,
      loading,
      t
    } = this.props;
    console.log('this.props', this.props);
    return <Layout>
        <Helmet>
          <title>{t("Create new business - HeresMyInfo.com")}</title>
        </Helmet>
        <Container>
          <h1>{t("Create new business")}</h1>
          <NewBusinessForm create={this.create} error={error} loading={loading} />
        </Container>
      </Layout>;
  }

}

const mapStateToProps = state => ({
  error: state.business.createError,
  loading: state.business.createLoading
});

const mapDispatchToProps = dispatch => ({
  create: (name, domain) => dispatch(create(name, domain))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(New));